
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { format, subMonths } from "date-fns";

interface GuardStatsMonthSelectorProps {
  selectedMonth: Date;
  onMonthChange: (date: Date) => void;
}

const GuardStatsMonthSelector: React.FC<GuardStatsMonthSelectorProps> = ({
  selectedMonth,
  onMonthChange
}) => {
  // Generate last 12 months options
  const monthOptions = Array.from({ length: 12 }, (_, i) => {
    const date = subMonths(new Date(), i);
    return {
      value: format(date, 'yyyy-MM'),
      label: format(date, 'MMMM yyyy')
    };
  });

  return (
    <div className="flex items-center space-x-2">
      <span className="text-sm font-medium">Select Month:</span>
      <Select
        value={format(selectedMonth, 'yyyy-MM')}
        onValueChange={(value) => {
          const [year, month] = value.split('-');
          const date = new Date(parseInt(year), parseInt(month) - 1, 1);
          onMonthChange(date);
        }}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Select a month" />
        </SelectTrigger>
        <SelectContent>
          {monthOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default GuardStatsMonthSelector;
